import {
  WSButton,
  WSCard,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSGrid,
  WSHorizontalScrollCards,
  WSLoader,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  getClientCompany,
  getClientEmail,
  getClientName
} from "../../../query/payments/selectors";
import { RecentClientsContainer } from "../RecentClientsContainer/RecentClientsContainer";

type Props = WSElementProps;

export const RecentClients: React.FC<Props> = ({ ...elementProps }) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <RecentClientsContainer
      loader={
        <WSElement {...elementProps}>
          <WSText.Heading2 mb="XS">Recent clients</WSText.Heading2>
          <WSLoader.Spinner />
        </WSElement>
      }
      zeroState={
        <WSElement {...elementProps}>
          <WSText.Heading3 mb="XS">Recent clients</WSText.Heading3>
          <WSText>No recent clients yet</WSText>
        </WSElement>
      }
      limit={4}
    >
      {memberClients => (
        <>
          <WSElement {...elementProps}>
            <WSFlexBox.CenterY justify="space-between" mb="M">
              <WSText.Heading3>Recent clients</WSText.Heading3>
              <WSButton.Link
                onClick={() => {
                  history.push("/member/invoices/contacts/clients");
                }}
              >
                Manage clients
              </WSButton.Link>
            </WSFlexBox.CenterY>

            <WSScreen XS S>
              <WSHorizontalScrollCards>
                {memberClients.map(memberClient => (
                  <WSCard
                    key={memberClient.memberClientId}
                    title={
                      getClientName(memberClient) ||
                      getClientEmail(memberClient)
                    }
                    content={getClientCompany(memberClient)}
                    primaryAction={{
                      label: "Create invoice",
                      onClick: () => {
                        history.push("/member/invoices/create", {
                          backPath: location.pathname,
                          memberClientId: memberClient.memberClientId
                        });
                      }
                    }}
                    headerLeft={{
                      text:
                        memberClient.name?.slice(0, 1) ||
                        memberClient.company?.slice(0, 1) ||
                        memberClient.emailTo?.slice(0, 1),
                      color: "blue100",
                      secondaryColor: "blue"
                    }}
                    size="S"
                  />
                ))}
              </WSHorizontalScrollCards>
            </WSScreen>
            <WSScreen M L XL>
              <WSGrid.Container>
                {memberClients.map(memberClient => (
                  <WSGrid.Item key={memberClient.memberClientId} M={3}>
                    <WSCard
                      title={
                        getClientName(memberClient) ||
                        getClientEmail(memberClient)
                      }
                      content={getClientCompany(memberClient)}
                      primaryAction={{
                        label: "Create invoice",
                        onClick: () => {
                          history.push("/member/invoices/create", {
                            backPath: location.pathname,
                            memberClientId: memberClient.memberClientId
                          });
                        }
                      }}
                      headerLeft={{
                        text:
                          memberClient.name?.slice(0, 1) ||
                          memberClient.company?.slice(0, 1) ||
                          memberClient.emailTo?.slice(0, 1),
                        color: "blue100",
                        secondaryColor: "blue"
                      }}
                      size="S"
                    />
                  </WSGrid.Item>
                ))}
              </WSGrid.Container>
            </WSScreen>
          </WSElement>
        </>
      )}
    </RecentClientsContainer>
  );
};
